export default {"src":"/assets/turbo/75158e61/universalat/_next/static/media/favicon.e116ed31.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};